module.exports = __webpack_public_path__ + "img/tree-group-white.f89218e6.svg";